<template>
  <div id="videoElem">
    <span>Shiyun</span>
    <video autoplay playsinline :src="this.videoSource" id="videoBot" @ended="changeSource()"/>
  </div>
</template>

<script>
import interact from "interactjs";

export default {
  name: "ResidencyVideoElem",
  data() {
    return {
      videoSource: null,
      x: 0,
      y: 0,
      i: null,
      videoList: [
      { 
        url: '../residency1/1.mp4', 
        top: "12vh", 
        left: "2vw"
      },
      {
        url: '../residency1/2.mp4', 
        top: "2vh", 
        left: "2vw"
      },
      {
        url: '../residency1/3.mp4', 
        top: "5vh", 
        left: "35vw"
      },
            { 
        url: '../residency1/4.mp4', 
        top: "2vh", 
        left: "2vw"
      },
      {
        url: '../residency1/5.mp4', 
        top: "5vh", 
        left: "15vw"
      },
      {
        url: '../residency1/6.mp4', 
        top: "4vh", 
        left: "28vw"
      }
    ]
    }
  },
  mounted() {
    let videoElem = document.getElementById('videoElem');
    this.enableDragDrop(videoElem);
    this.i = Math.floor(Math.random() * this.videoList.length);
    this.chooseFirstVideo(videoElem);
  },
  methods: {
    changeSource() {

      if (this.i < (this.videoList.length - 1)) {
        this.i++;
      }
      else {
        this.i = 0;
      }
      let videoElem = document.getElementById("videoElem");
      let selectedVideo = this.videoList[this.i];
      this.videoSource =  selectedVideo.url;
      videoElem.style.top = selectedVideo.top;
      videoElem.style.left = selectedVideo.left;


    },
    chooseFirstVideo(el) {
    let selectedVideo = this.videoList[this.i]
    this.videoSource =  selectedVideo.url;
    el.style.top = selectedVideo.top;
    el.style.left = selectedVideo.left;
    },
    enableDragDrop(container) {
      const VueThis = this;
      interact(container)
        .resizable({
          // resize from all edges and corners
          edges: { left: false, right: true, bottom: true, top: false },

          listeners: {
            move(event) {
              var target = event.target;
              let x = parseFloat(target.getAttribute("data-x")) || 0;
              let y = parseFloat(target.getAttribute("data-y")) || 0;

              // update the element's style
              target.style.width = event.rect.width + "px";
              target.style.height = event.rect.height + "px";

              // translate when resizing from top or left edges
              x += event.deltaRect.left;
              y += event.deltaRect.top;

              target.style.webkitTransform = target.style.transform =
                "translate(" + VueThis.x + "px," + VueThis.y + "px)";

              target.setAttribute("data-x", VueThis.x);
              target.setAttribute("data-y", VueThis.y);
            }
          },
          modifiers: [
            // keep the edges inside the parent
            interact.modifiers.restrictEdges({
              outer: document.getElementById("app")
            }),

            // minimum size
            interact.modifiers.restrictSize({
              min: { width: 100, height: 50 }
            }),

            interact.modifiers.aspectRatio({
              ratio: "preserve"
            }),
          ],
          inertia: true
        })
        .draggable({
          modifiers: [
            interact.modifiers.snap({
              targets: [interact.createSnapGrid({ x: 30, y: 30 })],
              range: Infinity,
              relativePoints: [{ x: 0, y: 0 }]
            }),
            interact.modifiers.restrict({
              restriction: document.getElementById("app"),
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
              // endOnly: true
            })
          ],
          inertia: true
        })
        .on("dragmove", function(event) {
          VueThis.x += event.dx;
          VueThis.y += event.dy;

          event.target.style.webkitTransform = event.target.style.transform =
            "translate(" + VueThis.x + "px, " + VueThis.y + "px)";
        });
    }
  }
}
</script>

<style scoped>
#videoElem {
  box-sizing:border-box;
  position:relative;
  height:100%;
  flex:1;
  margin:10px;
  background-color:#dbfcf0;
  filter: drop-shadow(0 0 0.3rem rgba(0, 0, 0, 0.733));
  z-index:500;
  font-size: 0;
}

div#videoElem{
  width:45vw;
  margin:150px;
  height:auto;
  position:absolute;
}

#videoElem >>> video {
  width:100%;
  height:100%;
  object-fit: cover;
}

span {
  position:absolute;
  color: black;
  background-color:#dbfcf0;
  top:-30px;
  text-align: center;
  width:100%;
  height:30px;
  z-index: 500;
  font-size:16px;
  line-height:30px;
} 

</style>